<template>
    <div class="horse-preview-pedigree flex flex-column gap-5" :style="style">
        <div class="flex justify-content-between pedigree-buttons">
            <div class="header">{{ $t('message.horseEdit.main.pedigree.header') }}</div>
            <CustomTextButton :label="$t('message.horseEdit.main.pedigree.seeGenerations')"
                              @click="morePedigreeDialog = true"/>
            <Dialog v-model:visible="morePedigreeDialog" :header="$t('message.horseEdit.main.pedigree.header')"
                    modal :closable="false" style="height: 1650px; width: 95%;">
                <template #header>
                    <div class="flex justify-content-between align-items-center w-full">
                        <span class="p-dialog-title">{{ $t('message.horseEdit.main.pedigree.header') }}</span>
                        <CustomButton :label="$t('message.horseEdit.save')" @click="() => morePedigreeDialog = false" />
                    </div>
                </template>
                <PedigreeHorse v-model="horse" :depthLasts="5" first class="p-3" editable onlyIconAddButton/>
            </Dialog>
        </div>
        <div class="horse-pedigree-graph">
            <PedigreeHorse v-model="horse" :depthLasts="2" first editable/>
        </div>
    </div>
</template>

<script>
import Dialog from "primevue/dialog";
import CustomTextButton from "@/components/form/CustomTextButton.vue";
import PedigreeHorse from "@/views/horse/horseList/components/PedigreeHorse.vue";
import CustomButton from "@/components/form/CustomButton.vue";

export default {
    name: "HorseEditMainPedigree",
    components: {
        PedigreeHorse,
        CustomTextButton,
        Dialog,
        CustomButton,
    },

    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            morePedigreeDialog: false,
            style: null
        };
    },

    emits: ["update:modelValue"],

    computed: {
        horse: {
            get() { return this.modelValue; },
            set(value) { this.$emit("update:modelValue", value); },
        },
    },
};
</script>

<style lang="scss">
@import "../../../../../assets/theme/mytheme/variables";
.horse-edit-main-pedigree {
    background-color: var(--secondary-color);
    padding: 2rem;
    border-radius: 7px;

    .header {
        font-size: 21px;
        text-transform: uppercase;
        font-weight: 600;
    }
    .horse-name {
        font-weight: 700;
        font-family: var(--decor-font-family);
        font-size: 22px;
    }
}
.imported-horse-form {
    .horse-pedigree-graph {
        overflow-x: auto;
    }
}
</style>
